export default {"src":"/_next/static/media/accidentOutline75_40.19c73400.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};